export const API = {
  LOGIN: {
    path: '/auth/login',
    method: 'POST',
  },
};
